document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('[id^="ingredient-slider-"]')
    .forEach((sectionEl) => {
      var slides = sectionEl.querySelectorAll(".ingredient-slide");
      var prevBtn = sectionEl.querySelector(".ingredient-arrow--prev");
      var nextBtn = sectionEl.querySelector(".ingredient-arrow--next");
      var totalSlides = slides.length;

      if (totalSlides <= 0) return;
      // Preview images for slot 1 and slot 2
      var slot1Items = sectionEl.querySelectorAll(
        ".ingredient-preview-slot--1 .ingredient-preview-img",
      );
      var slot2Items = sectionEl.querySelectorAll(
        ".ingredient-preview-slot--2 .ingredient-preview-img",
      );

      // Dot indicators
      var dots = sectionEl.querySelectorAll(".ingredient-dot");
      var activeBgColor =
        sectionEl.querySelector(".ingredient-slider-container")?.dataset
          .activeColor || "#000";
      var inactiveBgColor = "#d1d1d1";

      var currentIndex = 0;
      var isAnimating = false;
      var ANIM_DURATION = 560;

      function mod(n, m) {
        return ((n % m) + m) % m;
      }

      function updatePreviews(activeIndex) {
        var next1 = mod(activeIndex + 1, totalSlides);
        var next2 = mod(activeIndex + 2, totalSlides);

        // Slot 1: show the next ingredient image
        slot1Items.forEach(function (item) {
          item.classList.remove("is-visible", "is-exiting");
        });
        if (slot1Items[next1]) {
          slot1Items[next1].classList.add("is-visible");
        }

        // Slot 2: show the ingredient after next (half clipped)
        slot2Items.forEach(function (item) {
          item.classList.remove("is-visible", "is-exiting");
        });
        if (slot2Items[next2]) {
          slot2Items[next2].classList.add("is-visible");
        }
      }

      function updateDots(activeIndex) {
        dots.forEach(function (dot, i) {
          if (i === activeIndex) {
            dot.classList.add("is-active");
            dot.style.backgroundColor = activeBgColor;
          } else {
            dot.classList.remove("is-active");
            dot.style.backgroundColor = inactiveBgColor;
          }
        });
      }

      function goToSlide(newIndex, direction) {
        if (isAnimating || newIndex === currentIndex) return;
        isAnimating = true;

        var outSlide = slides[currentIndex];
        var inSlide = slides[newIndex];
        var exitClass =
          direction === "next" ? "slide-exit-left" : "slide-exit-right";
        var enterClass =
          direction === "next" ? "slide-enter-right" : "slide-enter-left";

        // 1. Position the incoming slide off-screen (no transition)
        inSlide.classList.add("no-transition", enterClass);
        inSlide.classList.remove("is-active");
        void inSlide.offsetWidth; // force reflow

        // 2. Remove no-transition so transitions kick in
        inSlide.classList.remove("no-transition");
        void inSlide.offsetWidth; // force reflow

        // 3. Animate: slide out the current, slide in the new
        outSlide.classList.remove("is-active");
        outSlide.classList.add(exitClass);

        inSlide.classList.remove(enterClass);
        inSlide.classList.add("is-active");

        // 4. Update preview images + dots
        updatePreviews(newIndex);
        updateDots(newIndex);

        // 5. Cleanup after animation completes
        setTimeout(function () {
          outSlide.classList.add("no-transition");
          outSlide.classList.remove(exitClass);
          void outSlide.offsetWidth; // force reflow
          outSlide.classList.remove("no-transition");
          currentIndex = newIndex;
          isAnimating = false;
        }, ANIM_DURATION);
      }

      // Arrow clicks
      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          goToSlide(mod(currentIndex + 1, totalSlides), "next");
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          goToSlide(mod(currentIndex - 1, totalSlides), "prev");
        });
      }

      // Dot clicks
      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          var idx = parseInt(this.dataset.dotIndex, 10);
          if (idx !== currentIndex) {
            var dir = idx > currentIndex ? "next" : "prev";
            goToSlide(idx, dir);
          }
        });
      });

      // Click on preview slot 1 → go to that slide
      slot1Items.forEach(function (item) {
        item.addEventListener("click", function () {
          var idx = parseInt(this.dataset.previewIndex, 10);
          if (idx !== currentIndex) {
            goToSlide(idx, "next");
          }
        });
      });

      // Touch / Swipe support (works on entire section for mobile)
      var touchStartX = 0;
      var touchEndX = 0;
      var swipeTarget = sectionEl.querySelector(
        ".ingredient-slider-right-area",
      );

      if (swipeTarget) {
        swipeTarget.addEventListener(
          "touchstart",
          function (e) {
            touchStartX = e.changedTouches[0].clientX;
          },
          { passive: true },
        );

        swipeTarget.addEventListener(
          "touchend",
          function (e) {
            touchEndX = e.changedTouches[0].clientX;
            var diff = touchStartX - touchEndX;

            if (Math.abs(diff) > 50) {
              if (diff > 0) {
                goToSlide(mod(currentIndex + 1, totalSlides), "next");
              } else {
                goToSlide(mod(currentIndex - 1, totalSlides), "prev");
              }
            }
          },
          { passive: true },
        );
      }

      // Set initial previews + dots
      updatePreviews(0);
      updateDots(0);
    });
});
